import React, { useEffect, useState, createContext, useContext } from 'react';
import { User, Role } from '../types';
interface AuthContextType {
  user: User | null;
  login: (name: string, password?: string) => boolean;
  logout: () => void;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export const AuthProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [user, setUser] = useState<User | null>(() => {
    const saved = localStorage.getItem('bmed_user');
    return saved ? JSON.parse(saved) : null;
  });
  useEffect(() => {
    if (user) {
      localStorage.setItem('bmed_user', JSON.stringify(user));
    } else {
      localStorage.removeItem('bmed_user');
    }
  }, [user]);
  const login = (name: string, password?: string) => {
    // In a real app, we'd verify against a database.
    // Here we check the DataContext users, but since AuthContext might be outside DataContext,
    // we'll handle the actual validation in the Login component and just set the user here.
    // For simplicity, we'll just accept the user object passed from the Login component.
    return false; // Not used directly, Login component will call setUser
  };
  const logout = () => {
    setUser(null);
  };
  return <AuthContext.Provider value={{
    user,
    login,
    logout,
    setUser: setUser as any
  }} data-id="element-74">
      {children}
    </AuthContext.Provider>;
};
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context as AuthContextType & {
    setUser: (user: User | null) => void;
  };
};